import { render } from "./Slots.vue?vue&type=template&id=1c9b3316"
import script from "./Slots.vue?vue&type=script&lang=js"
export * from "./Slots.vue?vue&type=script&lang=js"
script.render = render

export default script